import { Box, Button, HStack, Image, Spacer, Text } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AuthContext from '../Routes/hooks/AuthContext'
import store from 'store'

function AppHeader() {

	const { currentUser, signOut } = useContext(AuthContext)

	const navigate = useNavigate()

	const handleLogOut = () => {
		signOut()
			.then(() => {
				navigate("/", { replace: true });
				store.clearAll();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	return (
		<>
			<HStack bgColor='brand.100' p='2' width='full'>
				<Image height='40px' src='https://cdn.msgsndr.com/location%2FA52ECf1qqrHz4iEHx2q8%2Fimages%2F36f24ad5-c824-4de2-9dd6-6547cccd0848.png?alt=media' />
				<Spacer />
				{currentUser?.uid ? (
					<HStack>
						<Button onClick={() => handleLogOut()} colorScheme='red' variant='solid'>
							Logout
						</Button>
					</HStack>
				) : (
					<HStack>
						<Link to='/login'>
							<Button colorScheme='teal' variant='outline'>
								Login
							</Button>
						</Link>
					</HStack>
				)}
			</HStack>

		</>
	)
}

export default AppHeader